import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCompassSquare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCompassSquare"><Path d="M3.5 3.5H20.5V20.5H3.5V3.5Z" stroke="currentColor"/><Path d="M15 9L10 10L9 15L14 14L15 9Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconCompassSquare;
